<template>
    <div class="out-of-stock-btn-container">
        <div v-show="!notifcation_exists" class="text-left alert alert-success">
            <div v-if="type == 'oos-product'">
                <p class="font-weight-bold">🛑 Out of Stock.</p>
                <p v-show="user_id == null">Enter your email to be notified when this product is back in stock.</p>
                <p v-show="user_id != null">We'll notify your email when this product is back in stock.</p>
            </div>
            <div v-if="type == 'oos-crystal'">
                <h3>🔔 Be the first to know when {{ title }} is available!</h3>
                <p v-show="user_id == null">Enter your email to be notified when this crystal is available again.</p>
                <p v-show="user_id != null">We'll notify your email when this crystal is available again</p>
            </div>
            <input :class="{'is-invalid': errors.has('email') }" v-validate data-vv-rules="required|email" name="email" v-model="email" style="max-width:250px" class="d-inline form-control" placeholder="LeslieKnope@pawneecounty.com" autocomplete="email" v-if="user_id == null">
            <button type="button" class="d-inline-block btn btn-success" @click="notifyClick">
            🔔 Notify Me
            </button>
        </div>
        <div v-show="notifcation_exists" class="alert alert-success">
            <p>👍 You're set to receive a notification when this product is back in stock.</p>
            <button type="button" :disabled="loading" class="btn btn-sm btn-light" @click="deleteRequest">Cancel Notification</button>
        </div>
    </div>
</template>

<script>
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

export default {
    props: {
        user_id: {
          type: Number,
          default: null,
        },
        product_id: {
          type: Number,
          default: null
        },
        prev_notification_exists: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'oos-product'
        },
        title: {
            type: String,
            default: null
        }
    },
    data() {
        return  {
            loading: false,
            email: null,
            notifcation_exists: false,
            token: window.Laravel.csrfToken,
        }
    },
    mounted:function(){
        this.notifcation_exists = this.prev_notification_exists;
        this.email = this.$cookie.get('notification-email');
    },
    methods: {
        notifyClick() {
            this.$validator.validate().then(result => {
                if (!result) {
                    this.$toasted.show("Please fix the errors in your email.", {
                        type: 'error',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                    });
                }
                else
                {
                    if(this.email)
                    {
                       this.$cookie.set('notification-email', this.email);
                    }
                    this.notifictionRequest();
                }
            });
        },
        notifictionRequest()
        {
            this.loading = true;
            var _this = this;
            this.$http.post('/out-of-stock-notification',{
                _token:_this.token,
                type: 'create',
                notification: _this.type,
                user_id: _this.user_id,
                product_id: _this.product_id,
                email: _this.email,
            }).then(
                function(success) {
                    this.$toasted.show("You're set to be notified!", {
                        icon : 'check-circle',
                        iconPack: 'custom-class',
                        className: 'display-5',
                        type: 'success',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                        singleton : true,
                    });
                    _this.notifcation_exists = true;
                    _this.loading = false;
                }, function (error) {
                    this.$toasted.show(error.data.message, {
                        type: 'error',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                    });
                }
            );
        },
        deleteRequest()
        {
            this.loading = true;
            var _this = this;
            this.$http.post('/out-of-stock-notification',{
                _token:_this.token,
                type: 'delete',
                user_id: _this.user_id,
                notification: _this.type,
                product_id: _this.product_id,
                email: _this.email,
            }).then(
                function(success) {
                    this.$toasted.show("Notification Removed.", {
                        icon : 'check-circle',
                        iconPack: 'custom-class',
                        className: 'display-5',
                        type: 'success',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                        singleton : true,
                    });
                    _this.notifcation_exists = false;
                    _this.loading = false;
                }, function (error) {
                    this.$toasted.show(error.data.message, {
                        type: 'error',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                    });
                }
            );
        },
    },
    http: {
        root: '/root',
        headers: {
            'X-CSRF-Token': Laravel.csrfToken
        }
    }
    
};
</script>
